// api/axiosClient.js
import axios from 'axios';
import AuthHelper from 'features/Auth/authHelper';
import AppConfigs from 'general/constants/AppConfigs';
import AppRoute from 'general/constants/AppRoute';
import PreferenceKeys from 'general/constants/PreferenceKeys';
import ToastHelper from 'general/helpers/ToastHelper';
import Utils from 'general/utils/Utils';
import { t } from 'i18next';
import queryString from 'query-string';

const axiosClient = axios.create({
  baseURL: AppConfigs.env.apiUrl,
  headers: {
    'content-type': 'application/json',
    'Cache-Control': 'no-cache',
  },
  paramsSerializer: (params) => queryString.stringify(params),
});

axiosClient.interceptors.request.use(async (config) => {
  return config;
});

axiosClient.interceptors.response.use(
  (response) => {
    if (response && response.data) {
      return response.data;
    }

    return response;
  },
  (error) => {
    let errorMessage = null;
    const response = error.response;
    if (response && response.status === 401) {
      ToastHelper.showError(t('message401error'));
      // AuthHelper.signOut();
      // Utils.openInCurrentTab(AppRoute.auth);
    }

    if (response && response.data) {
      const data = response.data;
      const { result, reason, detail } = data;
      if (result === 'failed') {
        if (reason) {
          errorMessage = reason;
        } else if (detail) {
          errorMessage = detail;
        }
      }
    }
    if (errorMessage) {
      // ToastHelper.showError(errorMessage);
    }
    throw error;
  }
);

// Update base url
const updateAxiosBaseURL = (baseUrl) => {
  axiosClient.defaults.baseURL = baseUrl;
};

// Update access token
const updateAxiosAccessToken = (accessToken) => {
  axiosClient.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
};

// Remove access token
const removeAxiosAccessToken = () => {
  delete axiosClient.defaults.headers.common['Authorization'];
};

(() => {
  const isTokenValid = AuthHelper.checkAccessTokenValid();
  if (isTokenValid) {
    const token = localStorage.getItem(PreferenceKeys.accessToken);
    updateAxiosAccessToken(token);
  } else {
    AuthHelper.signOut();
  }
})();

export { removeAxiosAccessToken, updateAxiosAccessToken, updateAxiosBaseURL };

export default axiosClient;
